import { classList } from 'global/util';
import styles from './upperSection.module.scss';

const UpperSection = ({ children, className }) => {
  return <div className={classList(styles.wrapper, className)}>{children}</div>;
};

export default UpperSection;
